import './projects.css';
import energyInfrastructure101 from './static/energy-infrastructure-set-1-01.jpg';
import energyInfrastructure103 from './static/energy-infrastructure-set-1-03.jpg';
import energyInfrastructure106 from './static/energy-infrastructure-set-1-06.jpg';
import energyInfrastructure107 from './static/energy-infrastructure-set-1-07.jpg';
import energyInfrastructure202 from './static/energy-infrastructure-set-2-02.jpg';
import energyInfrastructure203 from './static/energy-infrastructure-set-2-03.jpg';
import energyInfrastructure205 from './static/energy-infrastructure-set-2-05.jpg';
import energyInfrastructure206 from './static/energy-infrastructure-set-2-06.jpg';
import industrial01 from './static/industrial-01.jpg';
import industrial02 from './static/industrial-02.jpg';
import industrial03 from './static/industrial-03.jpg';
import industrial05 from './static/industrial-05.jpg';
import industrial06 from './static/industrial-06.jpg';
import industrial07 from './static/industrial-07.jpg';
import industrial08 from './static/industrial-08.jpg';
import commercial02 from './static/commercial-02.jpg';
import commercial03 from './static/commercial-03.jpg';
import commercial05 from './static/commercial-05.jpg';
import commercial07 from './static/commercial-07.jpg';
import commercial08 from './static/commercial-08.jpg';
import commercial09 from './static/commercial-09.jpg';
import commercial10 from './static/commercial-10.jpg';
import residential01 from './static/residential-01.jpg';
import residential02 from './static/residential-02.jpg';
import residential03 from './static/residential-03.jpg';
import residential04 from './static/residential-04.jpg';
import { Container, Header, Icon, Image } from "semantic-ui-react";
import { useEffect, useRef } from "react";
import { register } from 'swiper/element/bundle';
import { useStore } from "../../store/store";
import { setActiveProject } from "../../store/reducer";

// https://swiperjs.com/swiper-api
// https://www.freecodecamp.org/news/how-to-set-up-swiper-element-in-a-react-application/#responsivebreakpointsinswiperelement
// https://swiperjs.com/blog/using-swiper-element-in-react
const Swiper = (props) => {
    const swiperRef = useRef(null);
    const {
        children,
        ...rest
    } = props;

    useEffect(() => {
        // Register Swiper web component
        register();

        // pass component props to parameters
        const params = {
            ...rest
        };

        // Assign it to swiper element
        Object.assign(swiperRef.current, params);

        // initialize swiper
        swiperRef.current.initialize();
    }, []);

    return (
        <swiper-container init="false" ref={swiperRef} style={{
            "--swiper-pagination-color": "#fff",
            "--swiper-navigation-color": "#fff"
        }}>
            {children}
        </swiper-container>
    );
}
const SwiperSlide = (props) => {
    const {
        children,
        ...rest
    } = props;

    return (
        <swiper-slide {...rest}>
            {children}
        </swiper-slide>
    );
}

const Projects = () => {
    const [{ activeProject }] = useStore();

    const [, dispatch] = useStore();

    const handleClick = (to) => {
        dispatch(setActiveProject(to));
    }

    const projects = [
        {
            name: "Energy and Infrastructure",
            images: [
                energyInfrastructure101,
                energyInfrastructure103,
                energyInfrastructure106,
                energyInfrastructure107,
                energyInfrastructure202,
                energyInfrastructure203,
                energyInfrastructure205,
                energyInfrastructure206
            ]
        },
        {
            name: "Industrial",
            images: [
                industrial01,
                industrial02,
                industrial03,
                industrial05,
                industrial06,
                industrial07,
                industrial08
            ]
        },
        {
            name: "Commercial",
            images: [
                commercial02,
                commercial03,
                commercial05,
                commercial07,
                commercial08,
                commercial09,
                commercial10
            ]
        },
        {
            name: "Residential",
            images: [residential01, residential02, residential03, residential04]
        }
    ]

    return (
        <Container fluid className="project">
            <Header
                textAlign='center'
                as='h1'
                content={projects[activeProject].name}
                className='project-name'
            />
            <Swiper
                    slidesPerView={1}
                    breakpoints={{ 992: { slidesPerView: 3, spaceBetween: 40 } }}
                    navigation={true}
                    pagination={true}
                    centeredSlides={true}
                    loop={true}
            >
                {projects[activeProject].images.map((imageSrc, slideKey) =>
                    <SwiperSlide key={slideKey}>
                        <Image src={imageSrc} centered/>
                    </SwiperSlide>
                )}
            </Swiper>
            {activeProject > 0 &&
                <Header
                    floated="left"
                    as='h2'
                    className='project-nav'
                    onClick={() => handleClick(activeProject-1)}
                >
                    <Icon name='caret left'/>
                    {projects[activeProject-1].name}
                </Header>
            }

            {activeProject < projects.length-1 &&
                <Header
                    floated="right"
                    as='h2'
                    className='project-nav'
                    onClick={() => handleClick(activeProject+1)}
                >
                    {projects[activeProject+1].name}
                    <Icon name='caret right'/>
                </Header>
            }

        </Container>
    );
};

export default Projects;
